import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    __dev__: boolean;
  }
}

window.__dev__ = environment?.dev ?? false;

const global = {};

export default global;
